var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"alert",class:_vm.variantClass},[_c('div',{staticClass:"alert-text"},[_vm._t("default",null,{"hide":_vm.hide})],2),(_vm.showCloseButton)?_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":_vm.hide}},[_c('span',[_vm._v("×")])]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }